@if (!soportada) {
  <div class="asignador-vacio">
    <mat-icon>info</mat-icon>
    <p>La categoría de este grupo no tiene entidades asignables todavía.</p>
    <button irxBoton="secundario" (click)="volver()">Volver</button>
  </div>
} @else {
  <div class="asignador-header">
    <div class="titulo">
      <button irxBotonIcono (click)="volver()" tooltip="Volver">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <span>
        Asignar {{ cfg?.etiqueta }} al grupo
        <!-- Badge del color del grupo con el nombre adentro -->
        <span
          class="irx-estado"
          [class.irx-estado--color]="!!colorGrupo"
          [class.irx-estado--neutro]="!colorGrupo"
          [style.--estado-color]="colorGrupo"
          [style.--estado-texto-sobre]="textoGrupo"
        >
          {{ grupo?.nombre }}
        </span>
      </span>
    </div>

    <div class="controles">
      <!-- Pertenencia -->
      <irx-segmentado
        [value]="pertenencia"
        (change)="setPertenencia($event.value)"
        aria-label="Pertenencia al grupo"
      >
        <irx-segmento value="todos">Todas</irx-segmento>
        <irx-segmento value="miembros">En este grupo</irx-segmento>
        <irx-segmento value="no">Fuera de este grupo</irx-segmento>
        <irx-segmento value="sin" tooltip="Sin ningún grupo de esta categoría">
          Sin grupos
        </irx-segmento>
      </irx-segmentado>

      <!-- Bulk sobre lo filtrado -->
      <div class="grupo-botones">
        <button
          irxBoton="principal"
          [disabled]="cargando"
          (click)="aplicarATodos('asignar')"
        >
          <mat-icon>playlist_add</mat-icon>
          Asignar filtradas
        </button>
        <button
          irxBoton="peligro-borde"
          [disabled]="cargando"
          (click)="aplicarATodos('quitar')"
        >
          <mat-icon>playlist_remove</mat-icon>
          Quitar filtradas
        </button>
      </div>
    </div>
  </div>

  <app-tabla
    [name]="name"
    [datos]="datos"
    [totalCount]="totalCount"
    [columnas]="columnas"
    [search]="search"
    [filtros]="filtros"
    [query]="query"
    (queryChange)="onQueryChange($event)"
    [emptyState]="{
      title: 'No hay ' + (cfg?.etiqueta || 'entidades') + ' para mostrar',
    }"
  ></app-tabla>
}
